import { Loader2, Wallet, Users, Heart, Gift, TrendingUp, Target } from "lucide-react";

function Card({ icon: Icon, label, value, testId }) {
  return (
    <div className="bg-amtm-surface border border-amtm-border rounded-xl p-4" data-testid={testId}>
      <div className="flex items-center gap-2 text-amtm-textMuted text-xs mb-1.5">
        <Icon className="h-3.5 w-3.5" /> {label}
      </div>
      <p className="font-display text-2xl text-amtm-text">{value}</p>
    </div>
  );
}

const money = (n) => `₹${Math.round(n || 0).toLocaleString("en-IN")}`;

/** Cards for the shared /admin/diwali/summary payload (fetched once by the
 * parent page - cards, both charts and the campaign/content table all read
 * off this same object, per the "one aggregation endpoint" requirement). */
export default function DiwaliSummaryCards({ data }) {
  if (!data) {
    return <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-amtm-teal" /></div>;
  }
  const { cards } = data;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-testid="diwali-summary-cards">
      <Card icon={Wallet} label="Total Raised" value={money(cards.total_raised)} testId="diwali-card-total-raised" />
      <Card icon={Users} label="Unique Donors" value={cards.unique_donors} testId="diwali-card-unique-donors" />
      <Card icon={Gift} label="One-time Total" value={money(cards.one_time_total)} testId="diwali-card-one-time-total" />
      <Card
        icon={Heart}
        label="Guardians Started"
        value={`${cards.guardians_started} (+${money(cards.monthly_value_added)}/mo)`}
        testId="diwali-card-guardians-started"
      />
      <Card icon={TrendingUp} label="Average Gift" value={money(cards.average_gift)} testId="diwali-card-average-gift" />
      <Card
        icon={Target}
        label="Progress to ₹10L Goal"
        value={`${money(cards.ticker_raised)} (${cards.progress_pct}%)`}
        testId="diwali-card-progress"
      />
    </div>
  );
}
